import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import useSignal from '../../hooks/useSignal';
import MarketRegimeCard from './MarketRegimeCard';
import AssetAnalysisCard from './AssetAnalysisCard';
import './SignalSnippet.css';

// Transform API data to component-friendly format
const transformAssetData = (assetData) => {
  if (!assetData) return null;
  return {
    current_price: assetData.current_price,
    bias: assetData.bias,
    confidence: Math.round((assetData.confidence || 0) * 100),
    trend: assetData.trend?.direction,
    support: assetData.nearest_supports?.[0]?.price,
    resistance: assetData.nearest_resistances?.[0]?.price,
    notes: assetData.current_zone?.description
  };
};

const SignalSnippet = () => {
  const navigate = useNavigate();
  const { signal, loading, error } = useSignal();

  if (loading) {
    return (
      <section className="signal-snippet-section">
        <div className="snippet-loading-state">
          <div className="shimmer loading-block tall" />
          <div className="shimmer loading-block" />
          <div className="shimmer loading-block" />
        </div>
      </section>
    );
  }

  if (error || !signal) {
    return null;
  }

  const { market_context, btc, avax } = signal;

  return (
    <section className="signal-snippet-section">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        {/* Market Overview */}
        <div className="snippet-market-overview">
          {market_context?.regime && (
            <MarketRegimeCard
              regime={market_context.regime}
              notes={market_context.notes}
            />
          )}
        </div>

        {/* Asset Analysis */}
        <h3 className="snippet-subsection-title">Asset Analysis</h3>

        <div className="snippet-assets-grid">
          {btc && <AssetAnalysisCard asset="BTC" data={transformAssetData(btc)} />}
          {avax && <AssetAnalysisCard asset="AVAX" data={transformAssetData(avax)} />}
        </div>

        {/* CTA */}
        <button className="snippet-view-full-btn" onClick={() => navigate('/signal')}>
          View Full Analysis
          <FaArrowRight />
        </button>
      </motion.div>
    </section>
  );
};

export default SignalSnippet;
